import React from 'react';
import { observer } from 'mobx-react';
import { BlockOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { LinkComponent } from '../../../LinkComponent';
import { ITariffCardItem } from '../../../../interfaces';
import { tF, tT } from '../../../../translate';
import TariffsStyles from '../../m_styles.less';

interface ITariffItemAssignedCards {
    cards?: ITariffCardItem[];
}

export const TariffItemAssignedCards: React.FC<ITariffItemAssignedCards> = observer(
    ({ cards }: ITariffItemAssignedCards) => {
        return (
            <div className={TariffsStyles.tariffItemAssignedItems}>
                <h2 className={TariffsStyles.header2}>{tF('Assigned Cards')}</h2>
                {cards?.length ? (
                    cards?.map((value, index) => {
                        return (
                            <div key={value.card_id + index} className={TariffsStyles.item}>
                                <BlockOutlined />
                                <div key={value.card_id}>
                                    <LinkComponent
                                        name={value.card_name}
                                        id={value.card_id}
                                        currentListComponent={'CardList'}
                                    />
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className={TariffsStyles.noItems}>
                        <InfoCircleOutlined /> {tT('No cards assigned to this tariff')}
                    </div>
                )}
            </div>
        );
    },
);
